import React from "react";
import { StarPicker } from "@/components/reviews/StarPicker";

const inputClass = "mt-1.5 w-full border border-border bg-white px-3.5 py-3 text-sm text-ink outline-none transition-colors placeholder:text-muted-foreground/70 focus:border-gold";

function Field({ id, label, hint, error, children }) {
  return (
    <div>
      <label htmlFor={id} className="text-luxe text-[10px] text-ink">
        {label} {hint && <span className="normal-case tracking-normal text-muted-foreground">({hint})</span>}
      </label>
      {children}
      {error && <p className="mt-1 text-xs text-destructive">{error}</p>}
    </div>
  );
}

export function ReviewFields({ form, errors, onChange, onRating }) {
  const set = (k) => (e) => onChange(k, e.target.value);
  return (
    <>
      <div className="mt-6">
        <label className="text-luxe text-[10px] text-ink">Your rating</label>
        <div className="mt-2"><StarPicker value={form.rating} onChange={onRating} /></div>
        {errors.rating && <p className="mt-1 text-xs text-destructive" data-testid="review-form-rating-error">{errors.rating}</p>}
      </div>

      <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <Field id="rv-name" label="Name" error={errors.name}>
          <input id="rv-name" value={form.name} onChange={set("name")} placeholder="Your name" data-testid="review-form-name" className={inputClass} />
        </Field>
        <Field id="rv-email" label="Email" hint="not published" error={errors.email}>
          <input id="rv-email" type="email" value={form.email} onChange={set("email")} placeholder="you@example.com" data-testid="review-form-email" className={inputClass} />
        </Field>
      </div>

      <div className="mt-4">
        <Field id="rv-title" label="Title" hint="optional">
          <input id="rv-title" value={form.title} onChange={set("title")} maxLength={120} placeholder="Sum it up in a few words" data-testid="review-form-title" className={inputClass} />
        </Field>
      </div>

      <div className="mt-4">
        <Field id="rv-body" label="Your review" error={errors.body}>
          <textarea id="rv-body" rows={4} value={form.body} onChange={set("body")} maxLength={2000} placeholder="How does it look and feel? How was the fit, finish and packaging?" data-testid="review-form-body" className={`${inputClass} resize-none`} />
        </Field>
      </div>
    </>
  );
}
